import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '~/lib/utils'

const badgeVariants = cva(
  'tag p-2xs sm:p-xs gap-xs max-w-[350px] inline-flex items-center font-bold focus:outline-hidden focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2 ',
  {
    variants: {
      backgroundColour: {
        'ink-blue': 'bg-blue-d text-white',
        'mid-blue': 'bg-blue-m text-white',
        'light-blue': 'bg-blue-l text-blue-d',
        chartreuse: 'bg-char text-blue-d',
        'light-pink': 'bg-pink text-blue-d',
        'light-aqua': 'bg-green text-blue-d',
        'light-purple': 'bg-purple text-blue-d',
        'light-orange': 'bg-orange text-blue-d'
      }
    },
    defaultVariants: {
      backgroundColour: 'ink-blue'
    }
  }
)

export type BadgeProps = {
  data: {
    label: string
    backgroundColour: VariantProps<typeof badgeVariants>['backgroundColour']
    icon?: Image
  }
  className?: string
}

function Badge({ data, className }: BadgeProps) {
  const previewUrl =
    'https://preview-websitemodern-uni-hull.cloud.contensis.com'

  const { label, backgroundColour, icon } = data

  const iconImage = ['ink-blue', 'mid-blue'].includes(backgroundColour ?? '')
    ? icon?.asset.sys.uri.replace('ink-blue', 'white')
    : icon?.asset.sys.uri

  return (
    <div className={cn(badgeVariants({ backgroundColour }), className)}>
      {icon?.asset.sys.uri && (
        <img
          className='sm:h-xs-plus sm:w-xs-plus h-xs lg:h-s lg:w-s w-xs'
          src={`${previewUrl}${iconImage}`}
          alt=''
          role='presentation'
        />
      )}
      {label}
    </div>
  )
}

export default Badge
